<template>
<div>
  <div class="col-md-12">
    <canvas height="110" id="planet-chart"></canvas>
  </div>
</div>
</template>

<script>
import moment from 'moment'
import Chart from 'chart.js'
export default {
  name: 'dropvspickup',
  data() {
    return {
      names: ["Drop","Pick"],
      startLimit:0,
      endLimit:6,
      endDate:'',
      loading: false,
      dataDropArray: [],
      dataPickArray: [],
      labelData: []
    //   values: [[10, 2, 15, 17]],
    };
  },
  watch:{
    // endDate(){
    //   this.loadData()
    // }
  },
  mounted() {
  },
  created(){
      this.endDate = moment().format('YYYY-MM-DD')
      this.loadData()
  },
  methods:{ 
    async loadData() {
      try {
        var datadrop = await this.$store.dispatch('get_drop_vehicle_between_dates',{start:this.start, end: this.end})
        var datapick = await this.$store.dispatch('get_pickup_vehicle_between_dates',{start:this.start, end: this.end})
        datadrop.data.forEach(x=> {
          var date = moment(x.endDate).format('YYYY-MM-DD')
          this.labelData.push(moment(x.endDate).format('MMM D'))
          this.dataDropArray.push(x.count)
          var dp = datapick.data.filter(pick => {
            return moment(pick.startDate).format('YYYY-MM-DD') === date
          })
          this.dataPickArray.push(dp ? dp[0].count : 0)
        })
      } finally {
        const ctx = document.getElementById('planet-chart');
        var dropVSpickData = {
          type: 'line',
          data: {
            labels: this.labelData,
            datasets: [
              {
                data: this.dataDropArray,
                label: "Drop",
                type: "line",
                backgroundColor: "rgba(54,73,93,0)",
                borderColor: "rgb(197, 0, 0)",
                borderWidth: 3
              },
              {
                data: this.dataPickArray,
                label: "Pick",
                type: "line",
                backgroundColor: "rgb(54, 162, 235, 0)",
                borderColor: "rgb(54, 162, 235)",
                borderWidth: 3
              }
            ]
          },
          options: {
            legend: {
              display: false
            },
            responsive: true,
            lineTension: 0,
            scales: {
              yAxes: [
                {
                  ticks: {
                    beginAtZero: false,
                    padding: 0
                  },
                  gridLines: {
                      color: "rgba(0, 0, 0, 0)",
                      drawBorder: false
                  },
                },
              ],
              xAxes: [
                {
                  ticks: {
                    beginAtZero: false,
                    padding: 0
                  },
                  gridLines: {
                      color: "rgba(128,0,0,0.04)",
                      drawBorder: false
                  },
                },
              ]
            }
          },
        }
        new Chart(ctx, dropVSpickData);
      }
    }
  },
  computed:{
    datas(){
        return this.$store.state.dropped_vehicle_between_date
    },
    pickup(){
        return this.$store.state.pickup_vehicle_between_date
    },
    values(){
        var arr = []
        var pickup = []
        this.datas.forEach(x => {
            arr.push(x.count)
        });
        this.pickup.forEach(x => {
            pickup.push(x.count)
        });
        
        return [arr,pickup]
    },
    difference(){
        var arr = []
        var pickup = []
        var difference = []
        this.datas.forEach(x => {
            arr.push(x.count)
        });
        this.pickup.forEach(x => {
            pickup.push(x.count)
        });
        for(var i in arr){
          difference.push(pickup[i]-arr[i])
        }
        
        return [difference]
    },
    today(){
      return moment().format('YYYY-MM-DD')
    },
    end() {
      var date = new Date(this.endDate);
      return moment(date).format('YYYY-MM-DD')
    },
    start() {
      var date = new Date(this.endDate);
      return moment(date - 10 * 24 * 3600 * 1000).format('YYYY-MM-DD')
    },
    yesterday(){
      var date = new Date(this.start)
      return  moment(date - 1* 24 * 3600 * 1000).format('YYYY-MM-DD')
    },
    tomorrow(){
      var date = new Date(this.endDate)
      return  moment(date + 1* 24 * 3600 * 1000).format('YYYY-MM-DD')
    }
  }
};
</script>

<style></style>